module.exports = __webpack_public_path__ + "img/2024.29c81ac5.jpg";